import { useTypedParams } from '@sorare/routing';

import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import { Wheel } from '@sorare/marketplace/src/components/Wheel';

import type { PageParams } from './__generated__/routeParams';

const MarketWheelRarityPage = () => {
  const { rarity } = useTypedParams<PageParams>();
  return <Wheel rarity={rarity as Rarity} />;
};
export default MarketWheelRarityPage;
